import React from 'react'

import Carousel from 'react-bootstrap/Carousel';

const CarouselTestimonial = () => {
  return (
    <Carousel>
      <Carousel.Item>
        <Carousel.Caption>
          <div className="testimonial-img d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="var(--bs-primary)" viewBox="0 0 448 512"><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/></svg>
          </div>
          <div className="testimonial-content d-flex flex-column align-items-center text-center pt-1">
              <p className="m-0 p-0">“EV Charging station is really fabulous 👌. It is very useful for charging of Electric bikes. Atumobile bike is highly Creative product from the house of Vnext. We are thankful to Vnext Management for the wonderful Innovatiion of Atumobile...”</p>
              <div className="testimonial-meta">
                  <h6>Srinivasarao Menda</h6>
              </div>
          </div>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <Carousel.Caption>
        <div className="testimonial-img d-flex justify-content-center align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="var(--bs-primary)" viewBox="0 0 448 512"><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/></svg>
        </div>
        <div className="testimonial-content d-flex flex-column align-items-center text-center pt-1">
            <p className="m-0 p-0">“I would Highly recommend this charging station unreservedly !!! Excellent Charging station with Nice Ambience.Seriously such a well Qualified/Customer Centric/Courtesy staff who guide u in every step…Their hospitality and customer responsiveness is damn awesome.”</p>
            <div className="testimonial-meta">
                <h6>deety damodhar</h6>
            </div>
        </div>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <Carousel.Caption>
        <div className="testimonial-img d-flex justify-content-center align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="var(--bs-primary)" viewBox="0 0 448 512"><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/></svg>
        </div>
        <div className="testimonial-content d-flex flex-column align-items-center text-center pt-1">
            <p className="m-0 p-0">“Worth for money.... They sre providing best i would say excellent service... Considering this will never make you regret!”</p>
            <div className="testimonial-meta">
                <h6>Prudvi Kumar</h6>
            </div>
        </div>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  )
}

export default CarouselTestimonial